import {deepMerge} from "grommet/utils";
import {
    Anchor,
    Box,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Footer,
    Grid,
    Grommet,
    grommet,
    Image, Nav,
    Page,
    Text
} from "grommet";
import {CircleInformation, Home, Info, Logout, Moon, ShareOption, Shop, Sun, Tag} from "grommet-icons";
import React, {useEffect, useState} from "react";
import AppBar from "../component/AppBar";
import CustomerDashboard from "../component/CustomerDashboard";
import {deleteRefreshToken, deleteToken, deleteUserID, getToken, getUserId} from "../utils/token";
import axios from "axios";
import QRScanner from "../component/QRScanner";
import ShopList from "../component/ShopList";
import Logo from "../assets/logo.png";
import api from "../utils/api";
import FooterApp from "../component/Footer/FooterApp";
import HeaderApp from "../component/HeaderApp";

function handleLogout(event) {
    event.preventDefault();
    deleteToken();
    deleteRefreshToken();
    deleteUserID();
    window.location.href = '/webapp';

}

const Shops = () => {
    const [shops, setShops] = useState([]);
    useEffect(() => {
        api.get(process.env.REACT_APP_BASE_API_URL + 'api/stores.json')
            .then(response => {
                setShops(response.data);
                //setStoreOffers(response.data.storeOffers);
                //setStores(response.data.stores);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const theme = deepMerge(grommet, {
        global: {
            colors: {
                brand: '#2AB458',
            },
            font: {
                family: "Roboto",
                size: "18px",
                height: "20px",
            },
        },
    });
    const [dark, setDark] = useState(false);
    const stores = [
        {
            name: 'Store 1',
            description: "Sample description",
            link: 'https://www.store1.com',
            hours: "08:00 - 19:00",
            location: {
                latitude: 37.7749,
                longitude: -122.4194
            }
        },
        {
            name: 'Store 2',
            link: 'https://www.store2.com',
            description: "Sample description",
            hours: "08:00 - 19:00",
            location: {
                latitude: 40.7128,
                longitude: -74.0060
            }
        },
        {
            name: 'Store 3',
            link: 'https://www.store3.com',
            description: "Sample description",
            hours: "08:00 - 19:00",
            location: {
                latitude: 51.5074,
                longitude: -0.1278
            }
        }
    ];
    return (
        <Grommet theme={theme} full={true}>

            <Box fill>
                <Box flex={false} tag="header">
                    <AppBar>
                        <HeaderApp />
                    </AppBar>
                </Box>
                <Box flex overflow="auto" animation={"zoomIn"}>
                    <Grid columns="medium" gap="medium" pad={{bottom: "medium"}} responsive={true}>
                            <ShopList shops={shops}/>
                            {/*<Card background="light-1" border="dark">
                            <CardHeader pad="medium">
                                <Text weight={"bold"} color={"brand"}>
                                    Personal Info
                                </Text>
                            </CardHeader>
                            <CardBody pad="medium">
                                <Box direction={"row"} pad={"small"} gap={"medium"}>
                                    <Text alignSelf={"center"} wordBreak={"break-all"}>
                                        Matteo Domenici
                                    </Text>
                                    <Image
                                        fit="cover"
                                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png"
                                    />

                                </Box>
                            </CardBody>
                            <CardFooter pad={{horizontal: "small"}} background="light-3">
                                <Button icon={<ShareOption color="plain"/>} hoverIndicator/>
                            </CardFooter>
                        </Card>*/}

                        {/*
            <Box pad="medium" gap="medium" width="large" direction={"row"}>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="cover"
                                src="https://cdn-icons-png.flaticon.com/512/657/657076.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Card Info
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="contain"
                                src="https://cdn-icons-png.flaticon.com/512/1507/1507683.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Scan QR code
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
            </Box>
        */}
                    </Grid>
                </Box>
                <Box flex={false} background="brand" >
                    <FooterApp />
                </Box>
            </Box>

        </Grommet>

    );
}

export default Shops;